/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import { passwordLabels } from '@aarhus-university/au-lib-react-components/src/lib/i18n';

const MailSentReceiptComponent = ({ mailReceiptHelp, goBackLink }) => (
  <div className="page__content__block">
    <div className="box theme--background-secondary">
      <div className="row row--equal-width-items">
        <div className="row__item">
          <h2 className="text--default-size text--pull">{passwordLabels[window.appLang].mailReceiptHelp}</h2>
          <p>{mailReceiptHelp}</p>
          <a className="a--text-link" href={goBackLink}>{passwordLabels[window.appLang].mailReceiptLink}</a>
        </div>
        <div className="row__item">
          <h2 className="text--default-size text--pull">{passwordLabels[window.appLang].supportHeader}</h2>
          <a className="a--text-link" href={passwordLabels[window.appLang].supportStudentLink}>{passwordLabels[window.appLang].supportStudentText}</a>
          <br />
          <a className="a--text-link" href={passwordLabels[window.appLang].supportStaffLink}>{passwordLabels[window.appLang].supportStaffText}</a>
        </div>
      </div>
    </div>
  </div>
);

MailSentReceiptComponent.propTypes = {
  mailReceiptHelp: PropTypes.string.isRequired,
  goBackLink: PropTypes.string.isRequired,
};

MailSentReceiptComponent.displayName = 'MailSentReceiptComponent';
export default MailSentReceiptComponent;
